/**
 * www.tidy.com serves the app's index.html for unknown paths instead of 404ing, so the
 * retired help.tidy.com/* developer links silently dropped people into the dashboard
 * rather than anywhere useful.
 */
export const DEVELOPER_DOCS_URL = 'https://www.tidy.com/docs/developers';

export const DEVELOPER_API_REFERENCE_URL = 'https://www.tidy.com/docs/developers/api-reference';

export const DEVELOPER_SUPPORT_EMAIL_URL = 'mailto:concierge@tidy.com';
